/* tslint:disable:max-line-length */
/* eslint-disable max-len */
import { ZuperNavigationItem } from '@zuper/components/zuper-navigation';

export const defaultNavigation: ZuperNavigationItem[] = [
    {
        id: 'jobs',
        title: 'Jobs',
        type: 'basic',
        icon: 'heroicons_solid:briefcase',
        link: '/jobs',
        moduleKey:'JOB'
    }
];
export const compactNavigation: ZuperNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_solid:chart-bar',
        link: '/dashboard',
        tooltip: 'breadcrumb.dashboard.title',
        moduleKey:'',
        localeKey: 'breadcrumb.dashboard.title'
    },
    {
        id: 'project',
        title: 'Project',
        type: 'basic',
        icon: 'heroicons_solid:clipboard-document-check',
        link: '/projects',
        tooltip: 'text.projects',
        moduleKey:'PROJECT',
        localeKey: 'text.projects'
    },
    {
        id: 'request',
        title: 'Request',
        type: 'basic',
        icon: 'heroicons_solid:wrench-screwdriver',
        link: '/request',
        tooltip: 'text.request',
        moduleKey:'REQUEST',
        localeKey: 'text.request'
    },
    {
        id: 'job_group',
        title: 'Jobs Group',
        type: 'aside',
        icon: 'heroicons_solid:briefcase',
        moduleKey:'',
        children: [
            {
                id: 'jobs',
                title: 'Jobs',
                type: 'basic',
                icon: 'heroicons_solid:briefcase',
                link: '/jobs',
                moduleKey: 'JOB',
                localeKey: 'text.jobs'
            }, {
                id: 'chats',
                title: 'Chats',
                type: 'basic',
                icon: 'heroicons_solid:chat',
                link: '/chats',
                moduleKey:'JOB',
                localeKey: 'text.messages'
            },
            {
                id: 'recurring_jobs',
                title: 'Recurring Jobs',
                type: 'basic',
                icon: 'heroicons_solid:refresh',
                link: '/recurring_jobs',
                moduleKey:'JOB',
                localeKey: 'text.recurring_jobs'
            }
        ]
    },
    // {
    //     id:'dispatch_board',
    //     title:'Dispatch Board',
    //     type: 'basic',
    //     icon: 'heroicons_solid:calendar',
    //     moduleKey:'SCHEDULE',
    //     link: '/dispatch_board',
    //     tooltip: 'Dispatch Board',
    // },
    // {
    //     id:'job_calendar',
    //     title:'Calendar',
    //     type: 'basic',
    //     icon: 'heroicons_solid:calendar',
    //     moduleKey:'SCHEDULE',
    //     link: '/calendar',
    //     tooltip: 'Calendar',
    //     hidden: true
    // },
    {
        id:'scheduler_group',
        title:'Schedule Group',
        type: 'aside',
        icon: 'heroicons_solid:calendar',
        moduleKey: '',
        children: [
            {
                id:'job_calendar',
                title:'Calendar',
                type: 'basic',
                icon: 'heroicons_solid:job_calendar',
                moduleKey:'SCHEDULE',
                link: '/calendar',
                localeKey: 'calendar.settings.calendar.title'
            },
            {
                id:'scheduler_menu',
                title:'Dispatch Board',
                type: 'basic',
                icon: 'heroicons_solid:calendar',
                moduleKey:'SCHEDULE',
                link: '/dispatch_board',
                localeKey: 'dispatch.nav.title'
            }
        ]
    },
    {
        id: 'customer_organization_property',
        title: 'Customers, Organizations and Properties',
        type: 'aside',
        icon: 'heroicons_solid:user-group',
        moduleKey:'',
        children: [
            {
                id: 'customers',
                title: 'Customers',
                type: 'basic',
                icon: 'heroicons_solid:users',
                link: '/customers',
                moduleKey:'CUSTOMER',
                localeKey: 'customers.text'
            }, {
                id: 'organizations',
                title: 'Organizations',
                type: 'basic',
                icon: 'heroicons_solid:office-building',
                link: '/organizations',
                moduleKey: 'ORGANIZATION',
                localeKey: 'text.organizations'
            }, {
                id: 'properties',
                title: 'Properties',
                type: 'basic',
                icon: 'heroicons_solid:office-building-2',
                link: '/property',
                moduleKey: 'PROPERTY',
                localeKey: 'text.properties'
            },
        ]

    },
    {
        id: 'timesheets',
        title: 'Timesheets & Timeoff',
        type: 'aside',
        icon: 'heroicons_solid:clock',
        link: '/timesheets',
        moduleKey: '',
        children: [
            {
                id: 'timesheet',
                title: 'Timesheets',
                type: 'basic',
                icon: 'heroicons_solid:clock',
                link: '/timesheets',
                moduleKey:'TIMESHEET',
                localeKey: 'breadcrumb.timesheet.title'
            }, {
                id: 'timeoff',
                title: 'Timeoff',
                type: 'basic',
                icon: 'heroicons_solid:calendar',
                link: '/timeoff',
                moduleKey: 'TIMESHEET',
                localeKey: 'text.timeoff'
            }, {
                id: 'shifts',
                title: 'Shifts',
                type: 'basic',
                icon: 'heroicons_solid:adjustments',
                link: '/shifts',
                moduleKey: 'USER',
                localeKey: 'shifts.label'
            }, {
                id: 'timelog_summary_page',
                title: 'Timelog Summary',
                type: 'basic',
                icon: 'tabler:timelog-summary',
                link: '/timelog',
                moduleKey: 'TIMESHEET',
                localeKey: 'text.timelog_summary'
            }
        ]
    },
    {
        id: 'products',
        title: 'Parts & Services',
        type: 'aside',
        icon: 'heroicons_solid:tag',
        link: '/products',
        moduleKey: 'PRODUCTS',
        children: [
            {
                id: 'products',
                title: 'Parts & Services',
                type: 'basic',
                icon: 'heroicons_solid:tag',
                link: '/products',
                moduleKey: 'PRODUCTS',
                localeKey: 'text.parts_&_service'
            }, {
                id: 'stock-transfer-order',
                title: 'Transfer Orders',
                type: 'basic',
                icon: 'tabler:arrows-right-left',
                link: '/transfer_orders',
                moduleKey: 'PRODUCTS',
                localeKey: 'text.transfer_orders'
            }, {
                id: 'price-list',
                title: 'Pricelists',
                type: 'basic',
                icon: 'tabler:circle-percentage',
                link: '/pricelists',
                moduleKey: 'PRODUCTS',
                localeKey: 'text.pricelists'
            }
        ]
    },
    {
        id:'product_groups',
        title:'Product Groups',
        type: 'basic',
        icon: 'heroicons_solid:calendar',
        moduleKey:'PRODUCTS',
        link: '/product_groups',
        tooltip: 'breadcrumb.parts_and_services.product_groups',
        hidden: true,
        localeKey: 'breadcrumb.parts_and_services.product_groups'
    },
    {
        id:'search',
        title:'Search',
        type: 'basic',
        icon: 'heroicons_solid:calendar',
        moduleKey:'',
        link: '/search',
        tooltip: 'text.search',
        hidden: true,
        localeKey: 'text.search'
    },
    {
        id: 'maps',
        title: 'Maps',
        type: 'basic',
        icon: 'heroicons_solid:map',
        link: '/maps',
        tooltip: 'text.maps',
        moduleKey: 'MAPS',
        localeKey: 'text.maps'
    },
    {
        id: 'quotations_group',
        title: 'Quotations Group',
        type: 'aside',
        icon: 'heroicons_solid:calculator',
        moduleKey:'',
        children: [
            {
                id: 'quotations',
                title: 'Quotes',
                type: 'basic',
                icon: 'heroicons_solid:calculator',
                link: '/estimates',
                moduleKey: 'ESTIMATES',
                localeKey: 'text.quotes'
            }, {
                id: 'invoices',
                title: 'Invoices',
                type: 'basic',
                icon: 'heroicons_solid:receipt-tax',
                link: '/invoices',
                moduleKey: 'INVOICE',
                localeKey: 'text.invoices'
            },
            {
                id: 'payments',
                title: 'Payments',
                type: 'basic',
                icon: 'heroicons_solid:credit-card',
                link: '/payments',
                moduleKey: 'PAYMENTS',
                localeKey: 'breadcrumb.payments.title'
            }, {
                id: 'financing',
                title: 'Financing',
                type: 'basic',
                icon: 'heroicons_solid:cash',
                link: '/financing',
                moduleKey: 'FINANCE',
                localeKey: 'text.financing'
            }
        ]
    },
    {
        id: 'contract_asset',
        title: 'Contracts & Assets',
        type: 'aside',
        icon: 'heroicons_solid:document-duplicate',
        moduleKey:'',
        children: [
            {
                id: 'contracts',
                title: 'Contracts',
                type: 'basic',
                icon: 'heroicons_solid:document-duplicate',
                link: '/contracts',
                moduleKey: 'SERVICE_CONTRACTS',
                localeKey: 'contracts.text'
            }, {
                id: 'assets',
                title: 'Assets',
                type: 'basic',
                icon: 'heroicons_solid:cube',
                link: '/asset_management',
                moduleKey: 'ASSETS',
                localeKey: 'text.assets'
            },
        ]
    },
    {
        id: 'reports_group',
        title: 'Reports Group',
        type: 'aside',
        icon: 'heroicons_solid:chart-pie',
        moduleKey: '',
        children:[
            {
                id: 'Reports',
                title: 'Reports',
                type: 'basic',
                icon: 'heroicons_solid:chart-pie',
                link: '/reports',
                moduleKey: 'REPORTS',
                localeKey: 'reports.text'
            },{
                id: 'advanced_reports',
                title: 'Reports',
                type: 'basic',
                icon: 'tabler:advanced-reports',
                link: '/advanced_reports',
                moduleKey: 'ADVANCED_REPORTS',
                localeKey: 'reports.text',
                badge:{
                  title:'Beta',
                  classes:'font-medium px-1 p-0.5 bg-orange-100 border-2 border-orange-200 rounded leading-none tracking-wide text-amber-600 ml-3'
                }
            },{
                id: 'Advanced Analytics',
                title: 'Advanced Analytics',
                type: 'basic',
                icon: 'heroicons_solid:presentation-chart-bar',
                link: '/advanced_analytics',
                moduleKey: 'ADVANCED_ANALYTICS',
                localeKey: 'breadcrumb.advanced_analytics.title'
            }
        ]
    },
    {
        id: 'zuper-connect',
        title: 'Zuper-Connect',
        type: 'basic',
        icon: 'heroicons_solid:call-logs',
        link: '/connect',
        tooltip: 'text.settings.channels.communications',
        moduleKey: 'CONNECT',
        localeKey: 'text.settings.channels.communications',
        hidden: true, // default hidden until user found out to be zuper agent
    },
    {
        id: 'workflows',
        title: 'Workflows',
        type: 'basic',
        icon: 'tabler:git-branch',
        link: '/workflow-builder',
        tooltip: 'text.workflows',
        moduleKey: 'WORKFLOW',
        localeKey: 'text.workflows',
        // hideInProduction: true // Can be used to hide the module from the menu in production
    },
    {
        id: 'settings',
        title: 'Settings',
        type: 'basic',
        icon: 'heroicons_solid:cog',
        link: '/settings',
        tooltip: 'text.settings',
        moduleKey: '',
        localeKey: 'text.settings'
    }
];
export const futuristicNavigation: ZuperNavigationItem[] = [
    {
        id: 'jobs',
        title: 'Jobs',
        type: 'basic',
        icon: 'heroicons_solid:briefcase',
        link: '/jobs',
        moduleKey: ''
    }
];
export const horizontalNavigation: ZuperNavigationItem[] = [
    {
        id: 'jobs',
        title: 'Jobs',
        type: 'basic',
        icon: 'heroicons_solid:briefcase',
        link: '/jobs',
        moduleKey: ''
    }
];
